import React from "react";
import logo from "../../assets/images/logo.png";

const Header = () => (
  <header className="main-header">
    <nav className="navbar navbar-static-top">
      <div className="navbar-top">
        <div className="container">
          <div className="row">
            <div className="col-sm-6 col-xs-12">
              <ul className="list-unstyled list-inline header-contact">
                <li>
                  {" "}
                  <i className="fa fa-phone"></i> <span>+212 658 986 213 </span>{" "}
                </li>
                <li>
                  {" "}
                  <i className="fa fa-envelope"></i>{" "}
                  <span>contact@ihelpaged.org</span>{" "}
                </li>
              </ul>
            </div>

            <div className="col-sm-6 col-xs-12 text-right">
              <ul className="list-unstyled list-inline header-social">
                <li>
                  {" "}
                  <div>
                    {" "}
                    <i className="fa fa-facebook"></i>{" "}
                  </div>{" "}
                </li>
                <li>
                  {" "}
                  <div>
                    {" "}
                    <i className="fa fa-twitter"></i>{" "}
                  </div>{" "}
                </li>
                <li>
                  {" "}
                  <div>
                    {" "}
                    <i className="fa fa-google"></i>{" "}
                  </div>{" "}
                </li>
                <li>
                  {" "}
                  <div>
                    {" "}
                    <i className="fa fa-youtube"></i>{" "}
                  </div>{" "}
                </li>
                <li>
                  {" "}
                  <div>
                    {" "}
                    <i className="fa fa fa-pinterest-p"></i>{" "}
                  </div>{" "}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="navbar-main">
        <div className="container">
          <div className="navbar-header">
            <button
              type="button"
              className="navbar-toggle collapsed"
              data-toggle="collapse"
              data-target="#navbar"
              aria-expanded="false"
              aria-controls="navbar"
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
            </button>

            <div className="navbar-brand" href="index.html">
              <img src={logo} alt="" style={{ height: 140 }} />
            </div>
          </div>

          <div id="navbar" className="navbar-collapse collapse pull-right">
            <ul className="nav navbar-nav">
              <li>
                <a className="is-active" href="index.html">
                  HOME
                </a>
              </li>
              <li>
                <a href="about.html">ABOUT</a>
              </li>
              <li className="has-child">
                <a>CAUSES</a>
              </li>
              <li>
                <a href="gallery.html">GALLERY</a>
              </li>
              <li>
                <a href="contact.html">CONTACT</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  </header>
);

export default Header;
